import { types } from "./types";

const initialState = {
  // data: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_REPORTS_BY_ORG_ID.SUCCESS:
      return {
        ...state,
        data: action.payload,
      }; 
    default:
      return state;
  }
}

export default reducer;
